import Vue from 'vue';

export default {
    getBrands(context, brandName) {
        const url = `v1/brands/suggest?brand_name=${brandName}`;
        return Vue.$axios.$get(url);
    },
};
